import { Theme } from '@mui/material'
import Box from '@mui/material/Box'
import React from 'react'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { Transaction } from '../../Profile/types'
import { useDimensions } from '../../../hooks/useDimensions'

export interface Column {
  id: string
  label: string
  minWidth?: number
  align?: 'right'
}

const columns: readonly Column[] = [
  {
    id: 'accountNumber',
    label: 'CC Number / Bank Account Number',
    minWidth: 170,
  },
  { id: 'accountType', label: 'CC Type / Bank Account Type', minWidth: 100 },
  {
    id: 'settleAmount',
    label: 'Settle Amount',
    minWidth: 150,
    align: 'right',
  },
  {
    id: 'submitTimeLocal',
    label: 'Submit Time',
    minWidth: 200,
  },
  {
    id: 'transactionStatus',
    label: 'Transaction Status',
    minWidth: 200,
  },
]

interface Props {
  transactions: Transaction[]
}
export const PortalTransactionsComponent: React.FC<Props> = ({
  transactions,
}) => {
  const { height } = useDimensions()

  const _transactions = React.useMemo(
    () =>
      transactions
        .filter(
          (t) =>
            t.transactionStatus === 'settledSuccessfully' ||
            t.transactionStatus === 'voided' ||
            t.transactionStatus === 'capturedPendingSettlement'
        )
        .map((t) => ({
          ...t,
          transactionStatus:
            t.transactionStatus === 'capturedPendingSettlement'
              ? 'Pending Settlement'
              : 'Settled Successfully',
        })),
    [transactions]
  )

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <Box
        sx={{
          py: 1,
          px: 2,
          bgcolor: (theme: Theme) => theme.palette.info.dark,
        }}
      >
        <Typography variant="h6">Completed Transactions</Typography>
      </Box>
      <TableContainer sx={{ minHeight: height - 425 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {_transactions.map((row) => {
              return (
                <TableRow hover tabIndex={-1} key={row.transId}>
                  {columns.map((column) => {
                    const value = row[column.id as keyof Transaction]
                    const isSettleAmount = column.id === 'settleAmount'
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {isSettleAmount ? `$${value}` : value}
                      </TableCell>
                    )
                  })}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
